import { render, staticRenderFns } from "./loginBox.vue?vue&type=template&id=136e3b24&scoped=true"
import script from "./loginBox.vue?vue&type=script&lang=js"
export * from "./loginBox.vue?vue&type=script&lang=js"
import style0 from "./loginBox.vue?vue&type=style&index=0&id=136e3b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e3b24",
  null
  
)

export default component.exports